export const VERSION = 'dev-master#346e73e';
